export async function checkInternet() {
  // This function checks if the internet connection is available by trying to fetch a known resource(our app logo).
  // If the fetch is successful, it returns true; otherwise, it returns false.
  try {
    const currentAppUrl = window.location.href
    let folderUrl

    if (currentAppUrl.includes('crowdcatch')) {
      folderUrl = '/crowdcatch'
    } else {
      folderUrl = '/partnerbrite'
    }

    await fetch(`${folderUrl}/favicon.ico`, { mode: 'no-cors' })
    return true
  } catch {
    return false
  }
}
